import { useState } from 'react'

import s from './ControlledStreamInfo.module.scss'

import { StreamGET } from 'types/creative'

import { CopyIcon } from 'assets/icons/CopyIcon'
import { PlayIcon } from 'assets/icons/PlayIcon'

import { Input } from 'components/Controls/Input/Input'

interface Props {
  streamData: StreamGET | null
}

export const ControlledStreamInfo = ({ streamData }: Props) => {
  const [copied, setCopied] = useState({ u: false, k: false, l: false, p: false })
  const copyToClipboard = (value?: string) => {
    if (value) navigator.clipboard.writeText(value)
  }
  return (
    <div className={s.wrapper}>
      <Input
        icon={<PlayIcon className={s.playIcon} />}
        label={
          <div className={s.labelWrapper}>
            <span>Public stream URL</span>
            <button
              className={s.copyButton}
              onClick={() => {
                copyToClipboard(streamData?.connection_url)
                setCopied({ u: true, k: false, l: false, p: false })
              }}
            >
              {copied.u ? 'Copied' : ''}
              <CopyIcon className={s.copyIcon} />
            </button>
          </div>
        }
        type="text"
        placeholder="connection_url: str"
        value={streamData?.connection_url || ''}
        readOnly
        onClick={(e: any) => {
          e.target.select()
          copyToClipboard(streamData?.connection_url)
          setCopied({ u: true, k: false, l: false, p: false })
        }}
      />

      <Input
        icon={<PlayIcon className={s.playIcon} />}
        label={
          <div className={s.labelWrapper}>
            <span>Private key</span>
            <button
              className={s.copyButton}
              onClick={() => {
                copyToClipboard(streamData?.stream_key)
                setCopied({ u: false, k: true, l: false, p: false })
              }}
            >
              {copied.k ? 'Copied' : ''}
              <CopyIcon className={s.copyIcon} />
            </button>
          </div>
        }
        type="text"
        placeholder="stream_key: str"
        value={streamData?.stream_key || ''}
        readOnly
        onClick={(e: any) => {
          e.target.select()
          copyToClipboard(streamData?.stream_key)
          setCopied({ u: false, k: true, l: false, p: false })
        }}
      />

      <Input
        icon={<PlayIcon className={s.playIcon} />}
        label={
          <div className={s.labelWrapper}>
            <span>Stream login</span>
            <button
              className={s.copyButton}
              onClick={() => {
                copyToClipboard(streamData?.streamer_username)
                setCopied({ u: false, k: false, l: true, p: false })
              }}
            >
              {copied.l ? 'Copied' : ''}
              <CopyIcon className={s.copyIcon} />
            </button>
          </div>
        }
        type="text"
        placeholder="streamer_login: str"
        value={streamData?.streamer_username || ''}
        onClick={(e: any) => {
          e.target.select()
          copyToClipboard(streamData?.streamer_username)
          setCopied({ u: false, k: false, l: true, p: false })
        }}
        readOnly
      />

      <Input
        icon={<PlayIcon className={s.playIcon} />}
        label={
          <div className={s.labelWrapper}>
            <span>Stream password</span>
            <button
              className={s.copyButton}
              onClick={() => {
                copyToClipboard(streamData?.streamer_password)
                setCopied({ u: false, k: false, l: false, p: true })
              }}
            >
              {copied.p ? 'Copied' : ''}
              <CopyIcon className={s.copyIcon} />
            </button>
          </div>
        }
        type="text"
        placeholder="streamer_password: str"
        value={streamData?.streamer_password || ''}
        onClick={(e: any) => {
          e.target.select()
          copyToClipboard(streamData?.streamer_password)
          setCopied({ u: false, k: false, l: false, p: true })
        }}
        readOnly
      />
    </div>
  )
}
